import {fetch} from 'utils/dataAccess';

/**
 * PUT /shipments/{id}/relay_point
 *
 * Only the carrier id travels: the API re-reads the relay point from the carrier and rewrites the
 * shipment address itself. 409 = waybill already generated, 404 = unknown relay, 502 = carrier down;
 * all of them come back as Error(message) thanks to noThrow.
 */
export default async function updateRelayPoint(shipmentIri, relayPointId) {
    const response = await fetch(
        `${shipmentIri}/relay_point`,
        {
            method: 'PUT',
            body: JSON.stringify({relayPointId}),
            headers: new Headers({'Content-Type': 'application/json'}),
        },
        false,
        true,
    );

    return await response.json();
}
